module.exports = {"Other":0,"CR":1,"LF":2,"Control":3,"Extend":4,"Regional_Indicator":5,"SpacingMark":6,"L":7,"V":8,"T":9,"LV":10,"LVT":11}


//////////////////
// WEBPACK FOOTER
// ./node_modules/grapheme-breaker/src/classes.json
// module id = EDU+
// module chunks = 0